<p-listbox
  #careTypeListbox
  [options]="options()"
  [ngModel]="selection"
  (ngModelChange)="onSelectionChange($event)"
  optionLabel="name"
  dataKey="id"
  [multiple]="true"
  [filter]="true"
  [filterBy]="'name'"
  [filterPlaceHolder]="'ASSISTANCE_CARE_LOG_EDITOR.SEARCH' | transloco"
  [autoOptionFocus]="false"
  [focusOnHover]="false"
  [metaKeySelection]="false"
  styleClass="w-full"
  [listStyle]="{ 'max-height': '300px' }"
>
  <ng-template pTemplate="item" let-careType>
    <span [title]="careType.name">{{ truncateLabel(careType.name) }}</span>
  </ng-template>
</p-listbox>
